import { styled } from '@mui/material';

export const HeaderText = styled('p')<{ colorScheme: string }>(({ colorScheme }) => ({
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '14px',
    color: colorScheme === 'dark' ? '#FFFFFF' : '#000000',
}));

export const getRoomShortName = (fullName: string | undefined): string | null => {
    if (!fullName) return null;
    const match = fullName.match(/Meeting Room (\d+)/i);
    if (match) return `MR${match[1]}`;
    const shortMatch = fullName.match(/^MR(\d+)$/i);
    if (shortMatch) return `MR${shortMatch[1]}`;
    return null;
};
